type XPlusYDiscountText = {
	base: string
	discount: string
}

export class XPlusYDiscount {
	private element: HTMLElement
	private input: HTMLInputElement
	private textElement: HTMLElement

	private text: XPlusYDiscountText
	private amountX: number
	private amountY: number

	private readonly updateDiscountTextEvents = ['input', 'change'] as const

	public constructor(element: HTMLElement) {
		this.element = element

		const input = element.querySelector<HTMLInputElement>('.js-x-plus-y-discount__input')
		const textElement = element.querySelector<HTMLElement>('.js-x-plus-y-discount__text')

		if (!input || !textElement) {
			throw new Error('QuantityDiscount: Missing input or text element.')
		}

		this.input = input
		this.textElement = textElement

		const baseText = this.element.dataset.xPlusYDiscountBaseText
		const discountText = this.element.dataset.xPlusYDiscountDiscountText
		const amountX = this.element.dataset.xPlusYDiscountAmountX
		const amountY = this.element.dataset.xPlusYDiscountAmountY

		if (!baseText || !discountText || !amountX || !amountY) {
			throw new Error('XPlusYDiscount: Incomplete dataset.')
		}

		this.amountX = parseInt(amountX)
		this.amountY = parseInt(amountY)
		this.text = {
			base: baseText,
			discount: discountText
		}

		// Attach handlers
		this.updateDiscountTextEvents.forEach((evenName) => {
			this.input.addEventListener(evenName, this.updateDiscountText.bind(this))
		})

		this.input.dispatchEvent(new Event('change', { bubbles: true }))
	}

	private updateDiscountText(): void {
		const remainderQuantity = parseInt(this.input.value) % (this.amountX + this.amountY)

		if (remainderQuantity >= this.amountX) {
			const remainingAmount = this.amountY - (remainderQuantity - this.amountX)

			this.textElement.innerText = this.text.discount.replace('%y%', String(remainingAmount))
		} else {
			const remainingAmount = this.amountX + this.amountY - remainderQuantity

			this.textElement.innerText = this.text.base
				.replace('%x%', String(remainingAmount))
				.replace('%y%', String(this.amountY))
		}
	}
}
